/* Configurateur perso custom (BiOui) - Phase 1 v3 - vanilla JS */
(function () {
  function rr(ctx, x, y, w, h, r) {
    if (typeof r === 'number') r = { tl: r, tr: r, br: r, bl: r };
    ctx.beginPath();
    ctx.moveTo(x + r.tl, y);
    ctx.lineTo(x + w - r.tr, y); ctx.arcTo(x + w, y, x + w, y + r.tr, r.tr);
    ctx.lineTo(x + w, y + h - r.br); ctx.arcTo(x + w, y + h, x + w - r.br, y + h, r.br);
    ctx.lineTo(x + r.bl, y + h); ctx.arcTo(x, y + h, x, y + h - r.bl, r.bl);
    ctx.lineTo(x, y + r.tl); ctx.arcTo(x, y, x + r.tl, y, r.tl);
    ctx.closePath();
  }

  function init() {
    var root = document.querySelector('[data-pcfg]'); if (!root) return;
    var canvas = document.getElementById('pcfg-canvas'), ctx = canvas.getContext('2d');
    var W = canvas.width, H = canvas.height;
    var state = { logo: null, text: '00', font: 'PerArial', color: 'rgb(20,120,199)', corners: 'right', lx: 0.5, ly: 0.5, scale: 1, rotation: 0 };

    // format par défaut = auto (45×98, 2 stickers) ; le template peut surcharger via
    // data-pcfg-w / data-pcfg-h / data-pcfg-count (ex. moto : 30×65, 1 sticker)
    var REAL_W = parseFloat(root.getAttribute('data-pcfg-w')) || 45;
    var REAL_H = parseFloat(root.getAttribute('data-pcfg-h')) || 98;
    var MAX_H = (REAL_W === 45 && REAL_H === 98) ? 110 : REAL_H; // auto : hauteur max des 2 tailles
    var COUNT = parseInt(root.getAttribute('data-pcfg-count'), 10) || 2;
    var M = 18, GAP = 24;
    var sw, sh, startX, startY, stickers;
    function layout() {
      var availW = (W - 2 * M - GAP * (COUNT - 1)) / COUNT, availH = H - 2 * M;
      var sc = Math.min(availW / REAL_W, availH / MAX_H); // échelle constante -> largeur figée
      sw = REAL_W * sc; sh = REAL_H * sc;
      startX = (W - (COUNT * sw + GAP * (COUNT - 1))) / 2; startY = (H - sh) / 2;
      stickers = [];
      for (var si = 0; si < COUNT; si++) stickers.push({ x: startX + si * (sw + GAP), y: startY });
    }
    layout();

    // --- Phase 2 : polices vectorisables (opentype) parsées depuis le base64 (Shopify ne convertit pas le JS) ---
    var otFonts = {};
    function b64ToAB(b64) { var bin = atob(b64), n = bin.length, u = new Uint8Array(n); for (var i = 0; i < n; i++) u[i] = bin.charCodeAt(i); return u.buffer; }
    if (window.opentype && window.PCFG_FONT_DATA) {
      Object.keys(window.PCFG_FONT_DATA).forEach(function (k) {
        try { otFonts[k] = window.opentype.parse(b64ToAB(window.PCFG_FONT_DATA[k])); } catch (e) { }
      });
    }

    function frameOf(s) { var pad = sw * 0.075; return { x: s.x + pad, y: s.y + sh * 0.05, w: sw - 2 * pad, h: sh * 0.49 }; }
    function fitScale() { var fr = frameOf(stickers[0]); return Math.min(fr.w * 0.92 / state.logo.width, fr.h * 0.92 / state.logo.height); }
    function corners() {
      var R = sw * 0.1;
      if (state.corners === 'left') return { tl: R, tr: 0, br: 0, bl: R };
      if (state.corners === 'none') return { tl: 0, tr: 0, br: 0, bl: 0 };
      return { tl: 0, tr: R, br: R, bl: 0 };
    }

    function drawSticker(s) {
      ctx.fillStyle = state.color;
      rr(ctx, s.x, s.y, sw, sh, corners()); ctx.fill();
      var fr = frameOf(s);
      if (state.logo) {
        ctx.save(); rr(ctx, fr.x, fr.y, fr.w, fr.h, 6); ctx.clip();
        var sc = fitScale() * state.scale;
        var lw = state.logo.width * sc, lh = state.logo.height * sc;
        var cx = fr.x + state.lx * fr.w, cy = fr.y + state.ly * fr.h;
        ctx.translate(cx, cy); ctx.rotate(state.rotation * Math.PI / 180);
        ctx.drawImage(state.logo, -lw / 2, -lh / 2, lw, lh);
        ctx.restore();
      } else {
        ctx.fillStyle = 'rgba(255,255,255,.45)'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.font = (sw * 0.16) + 'px Arial';
        ctx.fillText('LOGO', fr.x + fr.w / 2, fr.y + fr.h / 2);
        ctx.strokeStyle = '#fff'; ctx.lineWidth = 3; ctx.setLineDash([11, 8]);
        rr(ctx, fr.x, fr.y, fr.w, fr.h, 6); ctx.stroke(); ctx.setLineDash([]);
      }
      if (state.text.trim()) {
        ctx.fillStyle = '#fff'; ctx.textAlign = 'left'; ctx.textBaseline = 'middle';
        var fs = sh * 0.42; ctx.font = fs + 'px ' + state.font;
        var maxW = sw * 0.86;
        while (ctx.measureText(state.text).width > maxW && fs > 20) { fs -= 4; ctx.font = fs + 'px ' + state.font; }
        var m = ctx.measureText(state.text), cx2 = s.x + sw / 2, x2;
        if (m.actualBoundingBoxLeft != null && m.actualBoundingBoxRight != null) { x2 = cx2 - (m.actualBoundingBoxRight - m.actualBoundingBoxLeft) / 2; }
        else { x2 = cx2 - m.width / 2; }
        ctx.fillText(state.text, x2, s.y + sh * 0.77);
      }
    }
    function draw() { ctx.clearRect(0, 0, W, H); stickers.forEach(drawSticker); savePlacement(); }

    function q(s) { return root.querySelector(s); }
    function setA(sel, el) { root.querySelectorAll(sel).forEach(function (x) { x.classList.remove('is-active'); }); el.classList.add('is-active'); }
    function savePlacement() { var h = q('[data-pcfg-placement]'); if (h) h.value = 'x=' + state.lx.toFixed(3) + ' y=' + state.ly.toFixed(3) + ' scale=' + state.scale.toFixed(2) + ' rot=' + state.rotation; }
    function updateFontPreviews() { root.querySelectorAll('[data-pcfg-fonts] button').forEach(function (b) { b.textContent = state.text.trim() ? state.text.toUpperCase() : b.getAttribute('data-default'); }); }

    q('[data-pcfg-logo]').addEventListener('change', function (e) {
      var f = e.target.files[0], wrap = q('[data-pcfg-tools]');
      if (!f) { state.logo = null; state.logoDataURL = null; if (wrap) wrap.style.display = 'none'; draw(); return; }
      var img = new Image();
      img.onload = function () {
        state.logo = img; state.lx = 0.5; state.ly = 0.5; state.scale = 1; state.rotation = 0;
        var sl = q('[data-pcfg-logosize]'); if (sl) sl.value = 1;
        var rt = q('[data-pcfg-rotate]'); if (rt) rt.value = 0;
        if (wrap) wrap.style.display = 'block';
        draw();
      };
      img.src = URL.createObjectURL(f);
      var frd = new FileReader(); frd.onload = function () { state.logoDataURL = frd.result; }; frd.readAsDataURL(f);
    });
    var ti = q('[data-pcfg-text]'); if (ti) ti.addEventListener('input', function (e) { state.text = e.target.value; updateFontPreviews(); draw(); });
    root.querySelectorAll('[data-pcfg-fonts] button').forEach(function (b) { b.addEventListener('click', function () { state.font = b.getAttribute('data-font'); q('[data-pcfg-font-input]').value = b.getAttribute('data-label'); setA('[data-pcfg-fonts] button', b); draw(); }); });
    root.querySelectorAll('[data-pcfg-colors] button').forEach(function (b) { b.addEventListener('click', function () { state.color = b.getAttribute('data-color'); q('[data-pcfg-color-input]').value = b.getAttribute('data-color'); setA('[data-pcfg-colors] button', b); draw(); }); });
    root.querySelectorAll('[data-pcfg-corners] button').forEach(function (b) { b.addEventListener('click', function () { state.corners = b.getAttribute('data-corners'); q('[data-pcfg-corners-input]').value = b.getAttribute('data-label'); setA('[data-pcfg-corners] button', b); draw(); }); });
    var slider = q('[data-pcfg-logosize]'); if (slider) slider.addEventListener('input', function (e) { state.scale = parseFloat(e.target.value); draw(); });
    var rotate = q('[data-pcfg-rotate]'); if (rotate) rotate.addEventListener('input', function (e) { state.rotation = parseFloat(e.target.value); draw(); });
    var sizeSel = q('select[name="properties[Taille]"]'); if (sizeSel) sizeSel.addEventListener('change', function (e) { var o = e.target.options[e.target.selectedIndex]; REAL_W = parseFloat(o.getAttribute('data-w')) || 45; REAL_H = parseFloat(o.getAttribute('data-h')) || 98; layout(); draw(); });
    var qtyInput = q('[data-pcfg-qty]');
    function setQty(v) { v = Math.max(1, parseInt(v, 10) || 1); if (qtyInput) qtyInput.value = v; }
    var qm = q('[data-pcfg-qty-minus]'), qp = q('[data-pcfg-qty-plus]');
    if (qm) qm.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) - 1); });
    if (qp) qp.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) + 1); });
    if (qtyInput) qtyInput.addEventListener('change', function () { setQty(qtyInput.value); });

    // drag du logo (permissif : si un logo est chargé, on peut le saisir n'importe où)
    var dragging = false, last = null;
    function pos(e) { var r = canvas.getBoundingClientRect(); var p = e.touches ? e.touches[0] : e; return { x: (p.clientX - r.left) * (canvas.width / r.width), y: (p.clientY - r.top) * (canvas.height / r.height) }; }
    function down(e) { if (!state.logo) return; dragging = true; last = pos(e); canvas.style.cursor = 'grabbing'; e.preventDefault(); }
    function move(e) { if (!dragging) return; var pt = pos(e), fr = frameOf(stickers[0]); state.lx = Math.max(-0.15, Math.min(1.15, state.lx + (pt.x - last.x) / fr.w)); state.ly = Math.max(-0.15, Math.min(1.15, state.ly + (pt.y - last.y) / fr.h)); last = pt; draw(); e.preventDefault(); }
    function up() { dragging = false; canvas.style.cursor = 'grab'; }
    canvas.style.cursor = 'grab';
    canvas.addEventListener('mousedown', down); window.addEventListener('mousemove', move); window.addEventListener('mouseup', up);
    canvas.addEventListener('touchstart', down, { passive: false }); canvas.addEventListener('touchmove', move, { passive: false }); canvas.addEventListener('touchend', up);

    // --- Phase 2 : génération du fichier d'impression SVG (mm, calques CutContour) ---
    function rrPathMM(x, y, w, h, r) {
      if (typeof r === 'number') r = { tl: r, tr: r, br: r, bl: r };
      function n(v) { return Math.round(v * 1000) / 1000; }
      return 'M' + n(x + r.tl) + ',' + n(y) +
        ' H' + n(x + w - r.tr) + (r.tr ? ' A' + n(r.tr) + ',' + n(r.tr) + ' 0 0 1 ' + n(x + w) + ',' + n(y + r.tr) : ' L' + n(x + w) + ',' + n(y)) +
        ' V' + n(y + h - r.br) + (r.br ? ' A' + n(r.br) + ',' + n(r.br) + ' 0 0 1 ' + n(x + w - r.br) + ',' + n(y + h) : ' L' + n(x + w) + ',' + n(y + h)) +
        ' H' + n(x + r.bl) + (r.bl ? ' A' + n(r.bl) + ',' + n(r.bl) + ' 0 0 1 ' + n(x) + ',' + n(y + h - r.bl) : ' L' + n(x) + ',' + n(y + h)) +
        ' V' + n(y + r.tl) + (r.tl ? ' A' + n(r.tl) + ',' + n(r.tl) + ' 0 0 1 ' + n(x + r.tl) + ',' + n(y) : ' L' + n(x) + ',' + n(y)) + ' Z';
    }
    function cornersMM(stW) {
      var R = stW * 0.1;
      if (state.corners === 'left') return { tl: R, tr: 0, br: 0, bl: R };
      if (state.corners === 'none') return { tl: 0, tr: 0, br: 0, bl: 0 };
      return { tl: 0, tr: R, br: R, bl: 0 };
    }
    function buildPrintSVG() {
      var stW = REAL_W, stH = REAL_H, margin = 4.5, gap = 3;
      var AB_W = 2 * margin + COUNT * stW + (COUNT - 1) * gap, AB_H = stH + 9; // auto : 102×107 (inchangé)
      var st = [];
      for (var si = 0; si < COUNT; si++) st.push({ x: margin + si * (stW + gap), y: margin });
      var CUT = 'rgb(252,8,245)', CUTP = 'rgb(245,255,28)';
      // fond = aplat de couleur sur TOUTE la planche (dimension CutContour Plein)
      var design = '<rect x="0" y="0" width="' + AB_W + '" height="' + AB_H + '" fill="' + state.color + '"/>', cc = '', defs = '';
      st.forEach(function (s, i) {
        var crn = cornersMM(stW);
        var pad = stW * 0.075, fr = { x: s.x + pad, y: s.y + stH * 0.05, w: stW - 2 * pad, h: stH * 0.49 };
        if (state.logo && state.logoDataURL) {
          var fit = Math.min(fr.w * 0.92 / state.logo.width, fr.h * 0.92 / state.logo.height), sc = fit * state.scale;
          var lw = state.logo.width * sc, lh = state.logo.height * sc;
          var cx = fr.x + state.lx * fr.w, cy = fr.y + state.ly * fr.h, cid = 'pcfgclip' + i;
          defs += '<clipPath id="' + cid + '"><path d="' + rrPathMM(fr.x, fr.y, fr.w, fr.h, stW * 0.013) + '"/></clipPath>';
          design += '<g clip-path="url(#' + cid + ')"><image xlink:href="' + state.logoDataURL + '" width="' + lw + '" height="' + lh + '" x="' + (-lw / 2) + '" y="' + (-lh / 2) + '" transform="translate(' + cx + ' ' + cy + ') rotate(' + state.rotation + ')"/></g>';
        }
        if (state.text.trim() && otFonts[state.font]) {
          var font = otFonts[state.font], maxW = stW * 0.86, fs = stH * 0.42;
          // centrage sur la BOÎTE ENGLOBANTE réelle (et non l'avance) -> centre visuel exact, toutes polices
          var p0 = font.getPath(state.text, 0, 0, fs), bb = p0.getBoundingBox();
          if ((bb.x2 - bb.x1) > maxW) { fs = fs * maxW / (bb.x2 - bb.x1); p0 = font.getPath(state.text, 0, 0, fs); bb = p0.getBoundingBox(); }
          var cx = s.x + stW / 2 - (bb.x1 + bb.x2) / 2;
          var p = font.getPath(state.text, cx, s.y + stH * 0.77 + fs * 0.34, fs);
          design += '<path d="' + p.toPathData(3) + '" fill="#ffffff"/>';
        }
        cc += '<path d="' + rrPathMM(s.x, s.y, stW, stH, crn) + '" fill="none" stroke="' + CUT + '" stroke-width="0.353"/>';
      });
      return '<?xml version="1.0" encoding="UTF-8"?>\n<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="' + AB_W + 'mm" height="' + AB_H + 'mm" viewBox="0 0 ' + AB_W + ' ' + AB_H + '">' +
        '<defs>' + defs + '</defs>' +
        '<g id="Design">' + design + '</g>' +
        '<g id="CutContour">' + cc + '</g>' +
        '<g id="CutContour Plein"><rect x="0" y="0" width="' + AB_W + '" height="' + AB_H + '" fill="none" stroke="' + CUTP + '" stroke-width="0.353"/></g>' +
        '</svg>';
    }
    window.PCFG_buildSVG = buildPrintSVG;
    window.PCFG_state = state;
    window.PCFG_setSize = function (h) { REAL_H = h; layout(); };

    // --- Phase 2b : PDF d'impression (design JPEG + contours découpe vecteur CMJN) ---
    function buildPrintPDF(jpegU8, jpegW, jpegH, AB_W, AB_H, coins) {
      var K = 72 / 25.4, pageW = AB_W * K, pageH = AB_H * K;
      var stW = REAL_W, stH = AB_H - 9, margin = 4.5, gap = 3;
      var st = [];
      for (var si = 0; si < COUNT; si++) st.push({ x: margin + si * (stW + gap), y: margin });
      function crn(c) { var R = stW * 0.1; if (c === 'left') return { tl: R, tr: 0, br: 0, bl: R }; if (c === 'none') return { tl: 0, tr: 0, br: 0, bl: 0 }; return { tl: 0, tr: R, br: R, bl: 0 }; }
      function nz(v) { return Math.round(v * 1000) / 1000; }
      function rr(x, y, w, h, r) {
        var k = 0.5523, o = [];
        o.push(nz(x + r.tl) + ' ' + nz(y) + ' m');
        o.push(nz(x + w - r.tr) + ' ' + nz(y) + ' l');
        if (r.tr) o.push(nz(x + w - r.tr + r.tr * k) + ' ' + nz(y) + ' ' + nz(x + w) + ' ' + nz(y + r.tr - r.tr * k) + ' ' + nz(x + w) + ' ' + nz(y + r.tr) + ' c'); else o.push(nz(x + w) + ' ' + nz(y) + ' l');
        o.push(nz(x + w) + ' ' + nz(y + h - r.br) + ' l');
        if (r.br) o.push(nz(x + w) + ' ' + nz(y + h - r.br + r.br * k) + ' ' + nz(x + w - r.br + r.br * k) + ' ' + nz(y + h) + ' ' + nz(x + w - r.br) + ' ' + nz(y + h) + ' c'); else o.push(nz(x + w) + ' ' + nz(y + h) + ' l');
        o.push(nz(x + r.bl) + ' ' + nz(y + h) + ' l');
        if (r.bl) o.push(nz(x + r.bl - r.bl * k) + ' ' + nz(y + h) + ' ' + nz(x) + ' ' + nz(y + h - r.bl + r.bl * k) + ' ' + nz(x) + ' ' + nz(y + h - r.bl) + ' c'); else o.push(nz(x) + ' ' + nz(y + h) + ' l');
        o.push(nz(x) + ' ' + nz(y + r.tl) + ' l');
        if (r.tl) o.push(nz(x) + ' ' + nz(y + r.tl - r.tl * k) + ' ' + nz(x + r.tl - r.tl * k) + ' ' + nz(y) + ' ' + nz(x + r.tl) + ' ' + nz(y) + ' c'); else o.push(nz(x) + ' ' + nz(y) + ' l');
        o.push('h'); return o.join(' ');
      }
      var C = crn(coins);
      // contenu balisé par calque (BDC/EMC) + tons directs CutContour (CS/SCN)
      var cont = '';
      cont += '/OC /oc1 BDC\nq ' + nz(pageW) + ' 0 0 ' + nz(pageH) + ' 0 0 cm /Im0 Do Q\nEMC\n';
      cont += '/OC /oc2 BDC\nq ' + nz(K) + ' 0 0 ' + nz(-K) + ' 0 ' + nz(pageH) + ' cm 0.353 w 1 J 1 j /CS1 CS 1 SCN\n';
      st.forEach(function (s) { cont += rr(s.x, s.y, stW, stH, C) + ' S\n'; });
      cont += 'Q\nEMC\n';
      cont += '/OC /oc3 BDC\nq ' + nz(K) + ' 0 0 ' + nz(-K) + ' 0 ' + nz(pageH) + ' cm 0.353 w /CS2 CS 1 SCN\n';
      cont += '0 0 m ' + AB_W + ' 0 l ' + AB_W + ' ' + AB_H + ' l 0 ' + AB_H + ' l h S\nQ\nEMC\n';
      var jstr = '';
      for (var i = 0; i < jpegU8.length; i += 8192) jstr += String.fromCharCode.apply(null, jpegU8.subarray(i, i + 8192));
      var objs = [];
      objs[1] = '<< /Type /Catalog /Pages 2 0 R /OCProperties << /OCGs [10 0 R 11 0 R 12 0 R] /D << /Order [10 0 R 11 0 R 12 0 R] /ON [10 0 R 11 0 R 12 0 R] /BaseState /ON >> >> >>';
      objs[2] = '<< /Type /Pages /Kids [3 0 R] /Count 1 >>';
      objs[3] = '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + nz(pageW) + ' ' + nz(pageH) + '] /Resources << /XObject << /Im0 5 0 R >> /ColorSpace << /CS1 6 0 R /CS2 8 0 R >> /Properties << /oc1 10 0 R /oc2 11 0 R /oc3 12 0 R >> >> /Contents 4 0 R >>';
      objs[4] = '<< /Length ' + cont.length + ' >>\nstream\n' + cont + 'endstream';
      objs[5] = '<< /Type /XObject /Subtype /Image /Width ' + jpegW + ' /Height ' + jpegH + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + jstr.length + ' >>\nstream\n' + jstr + '\nendstream';
      objs[6] = '[/Separation /CutContour /DeviceCMYK 7 0 R]';
      objs[7] = '<< /FunctionType 2 /Domain [0 1] /C0 [0 0 0 0] /C1 [0.01 0.97 0.04 0] /N 1 >>';
      objs[8] = '[/Separation /CutContour#20Plein /DeviceCMYK 9 0 R]';
      objs[9] = '<< /FunctionType 2 /Domain [0 1] /C0 [0 0 0 0] /C1 [0.04 0 0.89 0] /N 1 >>';
      objs[10] = '<< /Type /OCG /Name (Design) >>';
      objs[11] = '<< /Type /OCG /Name (CutContour) >>';
      objs[12] = '<< /Type /OCG /Name (CutContour Plein) >>';
      var pdf = '%PDF-1.5\n', off = [];
      for (var j = 1; j <= 12; j++) { off[j] = pdf.length; pdf += j + ' 0 obj\n' + objs[j] + '\nendobj\n'; }
      var xref = pdf.length;
      pdf += 'xref\n0 13\n0000000000 65535 f \n';
      for (var m = 1; m <= 12; m++) pdf += ('0000000000' + off[m]).slice(-10) + ' 00000 n \n';
      pdf += 'trailer\n<< /Size 13 /Root 1 0 R >>\nstartxref\n' + xref + '\n%%EOF';
      var outb = new Uint8Array(pdf.length);
      for (var p = 0; p < pdf.length; p++) outb[p] = pdf.charCodeAt(p) & 0xff;
      return outb;
    }
    // Rend le design (sans les contours) en JPEG via canvas -> cb(err, u8, w, h, AB_W, AB_H)
    function buildDesignJPEG(cb) {
      try {
        var full = buildPrintSVG();
        var design = full.replace(/<g id="CutContour">[\s\S]*?<\/g>/, '').replace(/<g id="CutContour Plein">[\s\S]*?<\/g>/, '');
        var AB_W = 9 + COUNT * REAL_W + (COUNT - 1) * 3, AB_H = REAL_H + 9, dpi = 400;
        var pxW = Math.round(AB_W / 25.4 * dpi), pxH = Math.round(AB_H / 25.4 * dpi);
        var cnv = document.createElement('canvas'); cnv.width = pxW; cnv.height = pxH;
        var ctx = cnv.getContext('2d');
        var im = new Image();
        im.onload = function () {
          try {
            ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, pxW, pxH);
            ctx.drawImage(im, 0, 0, pxW, pxH);
            var b64 = cnv.toDataURL('image/jpeg', 0.92).split(',')[1];
            var bin = atob(b64), u8 = new Uint8Array(bin.length);
            for (var i = 0; i < bin.length; i++) u8[i] = bin.charCodeAt(i);
            cb(null, u8, pxW, pxH, AB_W, AB_H);
          } catch (e) { cb(e); }
        };
        im.onerror = function () { cb(new Error('svg render')); };
        im.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(design);
      } catch (e) { cb(e); }
    }

    // Ajout au panier (fetch direct -> gère l'upload du logo, contourne le JS du thème)
    var form = document.getElementById('pcfg-form');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault(); e.stopPropagation();
      var btn = form.querySelector('.pcfg__add'); var lbl = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Ajout en cours…'; }
      function post(fd) {
        fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Erreur'); }); return r.json(); })
          .then(function () { window.location.href = '/cart'; })
          .catch(function (err) { if (btn) { btn.disabled = false; btn.textContent = lbl; } alert('Erreur lors de l\'ajout au panier : ' + err.message); });
      }
      function send(previewBlob) {
        // le fichier d'impression PDF nécessite le rendu du design (asynchrone)
        buildDesignJPEG(function (err, u8, pxW, pxH, ABW, ABH) {
          var fd = new FormData(form);
          if (previewBlob) fd.append('properties[Aperçu]', previewBlob, 'apercu-perso.png');
          var svg = null; try { svg = buildPrintSVG(); } catch (e) { }
          var pdfOk = false;
          if (!err && u8) {
            try {
              var pu8 = buildPrintPDF(u8, pxW, pxH, ABW, ABH, state.corners);
              fd.append('properties[Fichier impression]', new Blob([pu8], { type: 'application/pdf' }), 'impression-perso.pdf');
              pdfOk = true;
              if (svg) fd.append('properties[_Fichier impression SVG]', new Blob([svg], { type: 'image/svg+xml' }), 'impression-perso.svg');
            } catch (e) { }
          }
          if (!pdfOk && svg) { // repli : SVG en principal si le PDF a échoué
            fd.append('properties[Fichier impression]', new Blob([svg], { type: 'image/svg+xml' }), 'impression-perso.svg');
          }
          post(fd);
        });
      }
      try { canvas.toBlob(function (blob) { send(blob); }, 'image/png'); } catch (e2) { send(null); }
    });

    // cale l'aperçu collant juste sous le header sticky/fixe du site
    (function () {
      var stage = root.querySelector('.pcfg__stage'); if (!stage) return;
      var hh = 0;
      document.querySelectorAll('header, #shopify-section-header, [id*="section-header"], [class*="site-header"], [class*="header__wrapper"], [class*="sticky"]').forEach(function (el) {
        var cs = getComputedStyle(el), rect = el.getBoundingClientRect();
        if ((cs.position === 'fixed' || cs.position === 'sticky') && rect.top < 70 && rect.height > 30 && rect.height < 280) hh = Math.max(hh, el.offsetHeight);
      });
      if (hh > 0) stage.style.top = (hh + 14) + 'px';
    })();

    updateFontPreviews();
    if (document.fonts && document.fonts.load) {
      Promise.all(['PerArial', 'PerCarstyle', 'PerT96'].map(function (f) { return document.fonts.load('40px ' + f); })).then(draw).catch(function () { });
    }
    draw();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
